import { dateFormat } from '@/filters/index.js'
import { getStatus } from './timeline-status.enum'
class TransactionTimelineManager {
  constructor (transactionList) {
    if (!transactionList) throw new Error('Missing transactionList!')
    if (!Array.isArray(transactionList))
      throw new Error('Prop transactionList isnt a array!')

    this.transactionList = transactionList
  }

  _adapterDataItem ({ item, index, timnelineLength }) {
    const formatItem = getStatus(item.status)?.format({
      status: item?.status,
      anti_fraud: item?.anti_fraud
    })
    return {
      textBadge: index.toString(),
      firstItem: timnelineLength === index,
      label: item.status,
      description: formatItem?.description,
      color: formatItem?.color,
      thirdLine: dateFormat(item.created_at, 'dateAndHour'),
      attemptId: item.id,
      amount: item.amount,
      data: {
        color: formatItem?.color,
        ...item
      }
    }
  }

  adapterDataTimeline () {
    const timnelineLength = this.transactionList.length
    let index = timnelineLength + 1
    return this.transactionList.map(item => {
      index--
      return this._adapterDataItem({ item, index, timnelineLength })
    })
  }
}

export default TransactionTimelineManager
